import React from 'react';
import { EditorWizardContext } from '../../../hoc/EditorWizard';
import { LocalizationContext } from '../../../hoc/Localization';
import { SettingsContext } from '../../../hoc/Settings';
import { getArticleByUrl } from '../../../utils/directory';
import TermsComponent from './Terms';
import WizardInput from '../Input';

const Terms = () => {
  const { blogLocale, t } = React.useContext(LocalizationContext);
  const { edited, updateContent } = React.useContext(EditorWizardContext);
  const { accepted: acceptedField, privacy: privacyField } = edited;
  const [state, setState] = React.useState([]);
  const {
    domainSettings: { blogCountry },
  } = React.useContext(SettingsContext);

  React.useEffect(() => {
    (async () => {
      setState(await getArticleByUrl('terms-and-conditions', [blogLocale, blogCountry]));
    })();
  }, []);

  const title = t('menu.terms');
  return (
    <WizardInput
      title={t('course.create.wizard.step0_1')}
      description={t('course.create.wizard.step0_2')}
    >
      <TermsComponent
        acceptedField={acceptedField}
        privacyField={privacyField}
        state={state}
        updateContent={updateContent}
        title={title}
        t={t}
      />
    </WizardInput>
  );
};

export default Terms;
